import React from 'react'
import { SearchWithExtras } from 'generated/api'
import { buildSearchBlocks, PreviousSearchBlocks } from './builder'
import { Data, Purpose, PurposeIcon, PurposeInfo, PurposeProduct, PurposeTitle, Wrapper } from './SearchSummary.style'
import { DomainThemeProvider } from 'components/patterns/themes/context/ThemeProvider'
import { FlexGroup, GrowingFlexGroup } from 'experiences/search/widgets/SearchSummary/Trivia'
import { Pending } from 'components/patterns/suspense/internals/types'

export interface SearchSummaryProps {
	search: SearchWithExtras
}

export const SearchSummary: React.FC<React.PropsWithChildren<Pending<SearchSummaryProps>>> = props => (
	<SearchSummaryLayout {...buildSearchBlocks(props)} />
)

export const PendingSearchSummary: React.FC<React.PropsWithChildren<unknown>> = () => <SearchSummary pending={true} />

const SearchSummaryLayout: React.FC<React.PropsWithChildren<PreviousSearchBlocks>> = ({
	icon,
	loanPurpose,
	productType,
	trivia,
	button,
	badge,
	backgroundIcon,
	theme
}) => {
	return (
		<DomainThemeProvider theme={theme}>
			<Wrapper>
				<Data>
					<Purpose>
						<PurposeIcon>{icon}</PurposeIcon>
						<PurposeInfo>
							<PurposeTitle>{loanPurpose}</PurposeTitle>
							<PurposeProduct>{productType}</PurposeProduct>
						</PurposeInfo>
						{badge}
						{backgroundIcon}
					</Purpose>
					<GrowingFlexGroup>{trivia}</GrowingFlexGroup>
					<FlexGroup>{button}</FlexGroup>
				</Data>
			</Wrapper>
		</DomainThemeProvider>
	)
}
